<template>
    <div>
        <div v-if="loading">
            <h2 class="mt-3 ml-3">Cargando...</h2>
        </div>
        <div v-else class="vx-row flex justify-center">
            <div class="vx-col sm:w-4/5 lg:w-2/3 md:w-3/4 pt-6">
                <vx-card title="" >

                    <div slot="no-body">
                        <img src="https://evolugy.mayfer.software/Evolugy/app-assets/images/pages/login.png" alt="content-img" class="responsive card-img-top">
                    </div>
                    
                    <div v-if="!hasActivePatient">
                        <h5>Paciente Nuevo</h5>
                        <p class="mt-2">¡Hola! Por favor completa la siguiente información para crear tu perfil como paciente.</p>
                    </div>
                    <div v-else>
                        <h5>Ficha Médica</h5>
                        <p class="mt-2">¡Hola! Por favor completa la siguiente información para crear completar tu perfil como paciente.</p>
                    </div>

                    <div class="mt-5">
                        <form-wizard color="rgba(var(--vs-primary), 1)"
                            :title="null" :subtitle="null"
                            backButtonText="Regresar"
                            next-button-text="Siguiente"
                            finishButtonText="Finalizar"
                        >
                            <tab-content title="Datos" class="mb-5" :before-change="validatePatientData">
                                <!--:before-change=" validatePatientData" -->
                                    <form data-vv-scope="patient-data">

                <div class="vx-col  w-full mt-5">
                    <p>¿Ya es paciente con nosotros?</p>
                                        <div class="vx-row">
                                            <div class="vx-col">
                                                <ul class="centerx ml-5 mt-3 flex">
                                                    <li class="inline mr-2">
                                                        <vs-radio v-model="existingPatient" name="exercise" :vs-value="true">Si</vs-radio>
                                                    </li>
                                                    <li>
                                                        <vs-radio v-model="existingPatient" name="exercise" :vs-value="false">No</vs-radio>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                    <!-- <vs-checkbox class="mt-4 mb-4" v-model="existingPatient">¿Ya es paciente con nosotros?</vs-checkbox> -->
                </div>
                <div v-if="!existingPatient">
              <div class="vx-row my-3 ml-1">
                <div class="vx-col w-full" >
                <h2>Nuevo Paciente</h2>
                </div>
              </div>
              <div class="vx-row mb-2">
                <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center" >
                  <vs-input class="w-full px-5" label="Nombre(s)*" placeholder="Nombre(s)"
                  name="nombres" v-validate="'required'" v-model="newPatient.first_name"/>
                  <span class="text-danger">{{ errors.first('new-patient.nombres') }}</span>
                </div>
                <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-center">
                  <vs-input class="w-full px-5" label="Apellidos(s)*" placeholder="Apellidos(s)"
                  name="apellidos" v-validate="'required'" v-model="newPatient.last_name" />
                  <span class="text-danger">{{ errors.first('new-patient.apellidos') }}</span>
                </div>
              </div>
              <div class="vx-row mt-4 mb-2">
                  <div class="vx-col w-full md:w-full flex flex-col inline">
                      <p class="pl-5" style="font-size: 13px;">Celular*</p>
                      <div class="vx-row">
                        <vue-country-code class="vx-col w-1/10 ml-8 flex max-height:70%"
                        :preferredCountries="['gt', 'mx', 'sv', 'ni', 'hn', 'cr']"
                        @onSelect="saveCode"
                        >
                        </vue-country-code>
                          <div class="vx-col w-2/3">
                              <vs-input class="px-5 inputx w-full"  placeholder="Número de Celular"
                                name="celular" v-validate="'required'" v-model="defaultPhone" />
                              <span class="ml-5 text-danger">{{ errors.first('new-patient.celular') }}</span>
                          </div>
                      </div>
                  </div>
                </div>
              <div class="vx-row mt-4 mb-5">
                <div class="vx-col  w-full flex flex-col items-center">
                  <vs-input class="w-full px-5" label="Correo Electrónico*" placeholder="Correo Electrónico"
                  name="email" v-validate="'required|email'" v-model="newPatient.email"/>
                  <span class="text-danger">{{ errors.first('new-patient.email') }}</span>
                </div>
              </div>
              <div>
                <div class="vx-row mt-4 mb-4">
                  <div class="vx-col w-full md:w-1/3 flex flex-col inline">
                      <p class="inline px-5 mb-3" style="font-size: 13px;">Sexo*</p>
                      <ul class="ml-6">
                        <li class="ml-3">
                          <vs-radio v-model="newPatient.gender" name="sexo" v-validate="'required'" vs-value="male">
                            Másculino
                          </vs-radio>
                        </li>
                        <li class="ml-3">
                          <vs-radio v-model="newPatient.gender" name="sexo" v-validate="'required'" vs-value="female">
                            Femenino
                          </vs-radio>
                        </li>
                      </ul>
                      <span class="text-danger ml-5">{{ errors.first('new-patient.sexo') }}</span>
                  </div>
                  <div class="vx-col w-full md:w-2/3 flex flex-col inline">
                      <p class="pl-5" style="font-size: 13px;">Fecha de Nacimiento*</p>
                      <datepicker class="px-5" placeholder="Seleccionar Fecha" format="yyyy-MM-dd" 
                        name="fecha_de_nacimiento" v-validate="'required'" v-model="newPatient.dob"></datepicker>
                      <span class="ml-5 text-danger">{{ errors.first('new-patient.fecha_de_nacimiento') }}</span>
                  </div>
                </div>
                <div class="vx-row mt-4 mb-2">
                  <div class="vx-col w-full md:w-full flex flex-col inline">
                      <p class="pl-5" style="font-size: 13px;">Identificación*</p>
                      <div class="vx-row">
                          <div class="vx-col w-1/3">
                              <v-select class="pl-5" placeholder="Documento" :options="['DPI','Cédula', 'Pasaporte']" :dir="$vs.rtl ? 'rtl' : 'ltr'"  
                              name="tipo" v-validate="'required'" v-model="newPatient.idtype" />
                              <span class="pl-5 text-danger">{{ errors.first('new-patient.tipo') }}</span>
                          </div>
                          <div class="vx-col w-2/3 ">
                              <vs-input class="px-5 inputx w-full"  placeholder="Número de identificación"
                                name="identificacion" v-validate="'required'" v-model="newPatient.idNum" />
                              <span class="ml-5 text-danger">{{ errors.first('new-patient.identificacion') }}</span>
                          </div>
                      </div>
                  </div>
                </div>
                <div class="vx-row mb-1">
                  <div class="vx-col w-full md:w-full flex flex-col inline">
                      <div class="vx-row">
                          <div class="vx-col w-full">
                              <p class="pl-5" style="font-size: 13px;">País</p>
                              <v-select class="px-5" placeholder="País" :options="getCountries" :dir="$vs.rtl ? 'rtl' : 'ltr'"  
                              name="pais" label="name" v-validate="''" v-model="newPatient.country" />
                              <span class="pl-5 text-danger">{{ errors.first('new-patient.pais') }}</span>
                          </div>
                      </div>
                  </div>
                </div>
                <div class="vx-row mb-1">
                  <div class="vx-col w-full md:w-full flex flex-col inline">
                      <div class="vx-row">
                           <div class="vx-col w-full ">
                            <p class="pl-5" style="font-size: 13px;">Ciudad</p>
                            <v-select 
                              :disabled="newPatient.country ? false : true" :options="newPatient.country ? getStates : []"
                              class="px-5" placeholder="Ciudad" :dir="$vs.rtl ? 'rtl' : 'ltr'"  
                              name="ciudad" v-validate="''" v-model="newPatient.city" />
                            <span class="ml-5 text-danger">{{ errors.first('new-patient.ciudad') }}</span>
                          </div>
                         
                      </div>
                  </div>
                </div>
                <div class="vx-row">
                  <div class="vx-col w-full md:w-full flex flex-col inline">
                      <div class="vx-row">
                          <div class="vx-col w-1/2">
                              <vs-input class="pl-5 inputx w-full" label="Dirección" placeholder="Dirección"
                                name="direccion" v-validate="''" v-model="newPatient.address" />
                              <span class="pl-5 text-danger">{{ errors.first('new-patient.direccion') }}</span>
                          </div>
                          <div class="vx-col w-1/2 ">
                              <vs-input class="pr-5 inputx w-full" label="Complemento" placeholder="Complemento dirección"
                                name="direccion_2" v-validate="''" v-model="newPatient.address_2" />
                              <span class="ml-5 text-danger">{{ errors.first('new-patient.direccion_2') }}</span>
                          </div>
                      </div>
                  </div>
                </div>
                
              </div>
            </div>
            <div v-else>
                <div class="vx-col md:w-1/2 sm:w-full w-full flex flex-col items-left" >
                  <vs-input class="w-full px-5" label="Ingrese su correo electronico para verificar sus datos" placeholder="Email"
                  name="email" v-validate="'required|email'" v-model="newPatient.email"/>
                  <span class="text-danger">{{ errors.first('new-patient.email') }}</span>
                  <div class="vx-col flex md:w-1/2 w-full mt-2">
                    <vs-button type="filled" icon-pack="feather" @click="checkExistingPatient" icon="icon-plus">Verificar</vs-button>
                  </div>
                  <div v-if="doesExist">
                      <div class="vx-col md:w-1/2 lg:w-1/2 sm:w-full mt-5 ml-4">
                                <h6 class="inline mr-2">Nombres:</h6>
                                <p class="inline"> {{newPatient.first_name}} </p>
                            </div>
                            <div class="vx-col md:w-1/2 lg:w-1/2 sm:w-full mt-2 ml-4">
                             <h6 class="inline mr-2">Apellidos:</h6>
                             <p class="inline"> {{newPatient.last_name}} </p>
                        </div>
                        <div class="vx-col md:w-1/2 lg:w-1/2 sm:w-full mt-2 ml-4">
                             <h6 class="inline mr-2">Correo Electrónico:</h6>
                             <p class="inline"> {{newPatient.email}} </p>
                        </div>
                </div>
                </div>
            </div>
              
              <vs-divider class="mt-6 mb-5" />
            
             <!-- <div class="vx-row pt-3 pb-6">
                <div class="vx-col w-full flex justify-center">
                  <vs-button class="mr-4" color="primary" type="filled" icon-pack="feather" icon="icon-mail"
                     @click="validateNewPatient">
                    Agregar
                  </vs-button>
                   <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-list" 
                    v-if="!registerPatient" @click="registerPatient = !registerPatient">
                    Registrar Datos
                  </vs-button>
                  <vs-button color="danger" class="mr-4" type="filled" icon-pack="feather" icon="icon-list" 
                    v-if="registerPatient" @click="registerPatient = !registerPatient">
                    Cancelar
                  </vs-button>
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-save" 
                    v-if="registerPatient" @click="validateNewPatient">
                    Registrar Usuario
                  </vs-button>
                </div>
              </div> -->
            </form>
                          </tab-content>

                            <tab-content title="Antecedentes" class="mb-5" :before-change="validateMidStep">
                                <div v-if="!existingPatient">
                                <div class="vx-row mb-5">
                                    <div class="vx-col w-full">
                                        <h5>Ficha del Paciente</h5>
                                    </div>
                                </div>
                                <div class="vx-row">
                                    <div class="vx-col flex flex-col w-1/4 pl-2">
                                        <p>Alergías</p>
                                        <vs-switch color="success" class="mt-3 ml-4" v-model="newPatient.meta.allergyBool">
                                            <span slot="on">Si </span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                    </div>
                                    <div class="vx-col flex flex-col w-3/4" v-if="newPatient.meta.allergyBool">
                                        <vs-textarea v-model="newPatient.meta.allergyVal" label="Detalle Alergías" class="ml-5 inline" rows="1" />
                                    </div>
                                </div>
                                <div class="vx-row mt-4 ">
                                    <div class="vx-col flex flex-col w-1/4 pl-2">
                                        <p>Enfermedades</p>
                                        <vs-switch color="success" class="mt-3 ml-4" v-model="newPatient.meta.conditionBool">
                                            <span slot="on">Si </span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                    </div>
                                    <div class="vx-col flex flex-col w-3/4" v-if="newPatient.meta.conditionBool">
                                        <vs-textarea v-model="newPatient.meta.conditionVal" label="Detalle Enfermedades" class="ml-5 inline" rows="1" />
                                    </div>
                                </div>
                                <div class="vx-row mt-4">
                                     <div class="vx-col w-full pl-2">
                                        <p>¿Utiliza medicamentos?</p>
                                    </div>
                                </div>
                                <div class="vx-row ">
                                    <div class="vx-col flex flex-col w-1/4 pl-2">
                                        <vs-switch color="success" class="mt-3 ml-4" v-model="newPatient.meta.MedsBool">
                                            <span slot="on">Si </span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                    </div>
                                    <div class="vx-col flex flex-col w-3/4" v-if="newPatient.meta.MedsBool">
                                        <vs-textarea v-model="newPatient.meta.MedsVal" label="Detalle Medicamentos" class="ml-5 inline" rows="1" />
                                    </div>
                                </div>
                                <div class="vx-row mt-4">
                                     <div class="vx-col w-full pl-2">
                                        <p>¿Tiene tratamientos?</p>
                                    </div>
                                </div>
                                <div class="vx-row ">
                                    <div class="vx-col flex flex-col w-1/4 pl-2">
                                        <vs-switch color="success" class="mt-3 ml-4" v-model="newPatient.meta.treatmentBool">
                                            <span slot="on">Si </span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                    </div>
                                    <div class="vx-col flex flex-col w-3/4" v-if="newPatient.meta.treatmentBool">
                                        <vs-textarea v-model="newPatient.meta.treatmentVal" label="Detalle Tratamiento" class="ml-5 inline" rows="1" />
                                    </div>
                                </div>
                                <div class="vx-row mt-4">
                                     <div class="vx-col w-full pl-2">
                                        <p>Antecedentes de Cáncer en la familia</p>
                                    </div>
                                </div>
                                <div class="vx-row ">
                                    <div class="vx-col flex flex-col w-1/4 pl-2">
                                        <vs-switch color="success" class="mt-3 ml-4" v-model="newPatient.meta.cancerBool">
                                            <span slot="on">Si </span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                    </div>
                                    <div class="vx-col flex flex-col w-3/4" v-if="newPatient.meta.cancerBool">
                                        <vs-textarea v-model="newPatient.meta.cancerVal" label="Detalle Antecedentes de Cancer" class="ml-5 inline" rows="1" />
                                    </div>
                                </div>
                                <div class="vx-row mt-4 ">
                                    <div class="vx-col flex flex-col w-1/4 pl-2">
                                        <p>Cirugías</p>
                                        <vs-switch color="success" class="mt-3 ml-4" v-model="newPatient.meta.surgeryBool">
                                            <span slot="on">Si </span>
                                            <span slot="off">No</span>
                                        </vs-switch>
                                    </div>
                                    <div class="vx-col flex flex-col w-3/4" v-if="newPatient.meta.surgeryBool">
                                        <vs-textarea v-model="newPatient.meta.surgeryVal" label="Detalle Cirugías" class="ml-5 inline" rows="1" />
                                    </div>
                                </div>                                
                                <div class="vx-row mt-4">
                                    <div class="vx-col lg:w-1/4 sm:w-full md:w-1/3">
                                        <p>¿Usted fuma?</p>
                                        <ul class="centerx ml-5 mt-3 flex">
                                            <li class="inline mr-4">
                                                <vs-radio v-model="newPatient.meta.smoke" name="smoke" :vs-value="true">Si</vs-radio>
                                            </li>
                                            <li>
                                                <vs-radio v-model="newPatient.meta.smoke" name="smoke" :vs-value="false">No</vs-radio>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="vx-col lg:w-3/4 sm:w-full md:w-2/3" v-if="newPatient.meta.smoke">
                                        <p>Si fuma, cuantos cigarros al día y desde hace cuento tiempo</p>
                                        <vs-textarea v-model="newPatient.meta.smokeDetail" class="" rows="1" />
                                    </div>
                                </div>
                                <div class="vx-row mt-4 ">
                                    <div class="vx-col flex flex-col w-1/2 pl-2">
                                        <p class="mb-2">Grupo sanguineo</p>
                                        <div class="flex ml-4 w-full">
                                            <v-select :options="['A+','O+','AB+','A-','O-','B-','AB-']" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" 
                                                v-model="newPatient.meta.blood_type" class="mb-4 md:mb-0 inputx w-full" 
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-row mt-4 ">
                                    <div class="vx-col flex flex-col w-1/2 pl-2">
                                        <p class="mb-2">Peso (Libras)</p>
                                        <div class="flex ml-4 w-full">
                                            <vs-input class="inputx w-full" placeholder="Peso (Libras)" v-model="newPatient.meta.weight" />
                                        </div>
                                    </div>
                                    <div class="vx-col flex flex-col w-1/2 pl-2">
                                        <p class="mb-2">Estatura (Metros)</p>
                                        <div class="flex ml-4 w-full">
                                            <vs-input class="inputx w-full" placeholder="Estatura (Metros)" v-model="newPatient.meta.height" />
                                        </div>
                                    </div>
                                </div>
                                <div class="vx-row mt-4 ">
                                    <div class="vx-col  w-full pl-2">
                                        <p>Hace Ejercicio</p>
                                        <div class="vx-row">
                                            <div class="vx-col">
                                                <ul class="centerx ml-5 mt-3 flex">
                                                    <li class="inline mr-2">
                                                        <vs-radio v-model="newPatient.meta.exercise" name="exercise" :vs-value="true">Si</vs-radio>
                                                    </li>
                                                    <li>
                                                        <vs-radio v-model="newPatient.meta.exercise" name="exercise" :vs-value="false">No</vs-radio>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vx-col  w-full mt-4" v-if="newPatient.meta.exercise">
                                        <p>Tipo de ejercicio</p>
                                        <div class="vx-row ">
                                            <div class="vx-col flex flex-col items-center w-full">
                                                <v-select placeholder="Tipo de ejercicio" class="mt-1 w-full"  v-model="newPatient.meta.exerciseType"
                                                    :options="['Caminar a paso ligero','Caminata regular', 'Trotar', 'Yoga', 'Aerobicos', 'Nadas', 'Bicicleta', 'Correr', 'Otro']" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                                    />
                                            </div>
                                        </div>
                                        <div class="vx-row mt-4 ">
                                            <div class="vx-col w-full">
                                               <p>¿Con qué frecuencia?</p>
                                            </div>
                                        </div>
                                        
                                        <div class="vx-row">
                                            <div class="vx-col w-full">
                                                <v-select placeholder="Frecuencia de ejercicio" class="mt-1 w-full"  v-model="newPatient.meta.exerciseFreq"
                                                    :options="['Una vez a semana','Dos veces a la semana', 'Tres veces a la semana', 'Cuatro veces a la semana', 'Cinco veces a la semana', 'Seis veces a la semana', 'Todos los días']" 
                                                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                                    />
                                            </div>
                                            <div class="vx-col w-full mt-4">
                                                <p>Tiempo (min)</p>
                                                <vs-input class="inputx w-full" placeholder="Tiempo (min)" v-model="newPatient.meta.exerciseTime" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                    </div>
                                <div v-else>
                                    <div class="vx-col  w-full mt-5">
                                            <h5>Porfavor siga a la siguiente ventana ya que es un paciente existente</h5>
                                        </div>
                                </div>
                            </tab-content>

                            <tab-content title="Cita Médica" class="mb-5" :before-change="validateCitaMed">
                                <form data-vv-scope="cita-med">
                                    <div class="vx-row">
                                        <div class="vx-col  w-full mt-6">
                                            <h4 class="my-4">Datos de la Reserva</h4>
                                        </div>
                                        <div class="vx-col  w-full mt-2 mb-3">
                                            <h5 class="my-2">Clínica</h5>
                                            <v-select class="w-full" :options="docClinics" label="title" 
                                                v-validate="'required'"  name="clinica" 
                                                :reduce="option => option.id"  v-model="eventData.clinic_id" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                                :selectable="option => !(option.meta.zoom_active && option.meta.zoom_active.toLowerCase() == 'false')"
                                                >
                                                    <template v-slot:option="option">
                                                        <img class="mr-2 inline"  :src=" option.meta.type.toLowerCase() == 'virtual' ? 
                                                        'https://img.icons8.com/ios/24/000000/zoom.png' :
                                                        'https://img.icons8.com/material-outlined/24/000000/hospital-3.png' "/>
                                                        <p class="inline"
                                                        :class="(option.meta.type.toLowerCase() == 'virtual') && (option.meta.zoom_active) && !(option.meta.zoom_active == 'true')
                                                            ? 'text-danger' : 'text-primary'"
                                                        >{{ 
                                                        (option.meta.type.toLowerCase() == 'virtual')
                                                        && (option.meta.zoom_active) && !(option.meta.zoom_active == 'true')
                                                        ?  `${option.title} - Sin Activar` : option.title
                                                        }}</p>
                                                    </template>
                                                </v-select> 
                                            <span class="text-danger">{{ errors.first('cita-med.clinica') }}</span>
                                        </div>
                                        <div class="vx-row w-full mt-3 pl-3">
                                            <div class="vx-col w-1/2 ">
                                                <h5 class="my-2">Fecha</h5>
                                                <flat-pickr class="w-full" :config="configdateTimePicker" v-model="eventData.date" placeholder="Fecha"
                                                    v-validate="'required'" name="fecha" />
                                                <span class="text-danger w-full">{{ errors.first('cita-med.fecha') }}</span>
                                            </div>
                                            <div class="vx-col w-1/2 ">
                                                <h5 class="my-2">Hora</h5>
                                                <v-select v-if="eventData.date && eventData.clinic_id" :options="clinicAvailabilityByDate" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                                name="hora" v-validate="'required'" class="w-full style-chooser"  v-model="eventData.hour" 
                                                    :reduce="option => new Date(option.date1).toISOString().split('T')[1].substring(0,5)"
                                                    :selectable="option => option.available"
                                                >
                                                <template slot="selected-option" slot-scope="option">
                                                    {{ `${convertUTC_TIME(option.date1)} - ${convertUTC_TIME(option.date2)}` }}
                                                </template>
                                                    <template v-slot:option="option">
                                                    <p class="inline" :class="option.available ? 'text-primary' : 'text-danger'">{{ 
                                                        `${convertUTC_TIME(option.date1)} - ${convertUTC_TIME(option.date2)}`
                                                    }}</p>
                                                    <small v-if="!option.available" class="ml-2 text-danger">
                                                        No Disponible
                                                    </small>
                                                    </template>
                                                </v-select>
                                                <p class="my-1 text-secondary" v-else >Selecciona una fecha y clínica para determinar la disponibilidad</p>
                                                <span class="text-danger">{{ errors.first('cita-med.hora') }}</span>
                                            </div>
                                        </div>
                                        <div class="vx-col  w-full mt-5">
                                            <h5>Motivo de la Consulta</h5>
                                        </div>
                                        <div class="vx-col  w-full mt-5">
                                            <p>Explique todos los síntomas y/o motivos para su consulta.</p>
                                        </div>
                                        <div class="vx-col sm:w-full md:w-2/3 w-full">
                                            <vs-textarea v-model="consultationDetail.comments_obs" v-validate="'required'" name="motivo_consulta" label="Descripción del Motivo de Consulta" class="mb-0 md:mt-10 mt-6" rows="3" />
                                            <span class="text-danger w-full">{{ errors.first('cita-med.motivo_consulta') }}</span>
                                            <small class="w-full"><br>Para agendar la reserva debe indicar un motivo de consulta.</small>
                                        </div>
                                        <div class="vx-col sm:w-full md:w-1/3 pt-3 w-full">
                                            <h6>Síntomas COVID</h6>
                                            <ul class="centerx ml-4">
                                                <!-- <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.pressure">Presión alta</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mb-2" v-model="consultationDetail.main_symptoms.fever">Fiebre</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mb-2" v-model="consultationDetail.main_symptoms.nausea">Nausea</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mb-2" v-model="consultationDetail.main_symptoms.tiredness">Cansancio</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mb-2" v-model="consultationDetail.main_symptoms.fatigue">Fatiga</vs-checkbox>
                                                </li> -->
                                                <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.fever">Fiebre</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.dryCough">Tos Seca</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.tiredness">Cansancio</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.throatPain">Dolor de Garganta</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.diarrhea">Diarrea</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.headache">Dolor de Cabeza</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.smellTasteLoss">Perdida del sentido del olfato o del gusto</vs-checkbox>
                                                </li>
                                                <li>
                                                    <vs-checkbox class="mt-4 mb-2" v-model="consultationDetail.main_symptoms.breathingDifficulty">Dificultad para respirar</vs-checkbox>
                                                </li>
                                            </ul>
                                        </div>
                                       <!-- <vs-divider></vs-divider>
                                        <div class="vx-col  w-full mt-5">
                                            <vs-checkbox class="mt-4 mb-4" v-model="consultationDetail.previousConsultation">Es seguimiento de otra consulta?</vs-checkbox>
                                        </div>
                                        <div v-if="!consultationDetail.previousConsultation == true">
                                        <vs-row vs-w="12" class="my-3 px-3" >
                                            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="6">
                                            <h5>Preguntas del Doctor</h5>
                                            </vs-col>
                                        </vs-row>
                                        <vs-row class="px-3 mt-2" vs-w="12" v-for="(question, key) in customQuestions" :key="key"  >
                                            <vs-col vs-type="flex" vs-justify="flex-start" vs-align="flex-start" vs-w="12" v-if="question.active">
                                            <div class="vx-col w-full">
                                                <p>{{question.title}}</p>
                                                <vs-textarea v-bind:readonly="isReadOnly" v-model="customQuestionsAnswers[key]" :label="question.instructions" class="mb-3" rows="1" />
                                            </div>
                                            </vs-col>
                                        </vs-row>
                                        </div> -->
                                        <vs-divider></vs-divider>
                                        
                                    </div>
                                </form>
                            </tab-content>
                            <!-- tab 3 content -->
                            <tab-content title="Confirmación" class="mb-5" :before-change="validateLastStep">
                                <form data-vv-scope="last-step">
                                    <div class="vx-row">
                                        <div class="vx-col  w-full mt-5"> 
                                            <h4>Verificar Información</h4>
                                        </div>
                                        <div class="vx-col  w-full mt-5">
                                            <h5>Información Personal</h5>
                                        </div>
                                        <div class="vx-col md:w-1/2 lg:w-1/2 sm:w-full mt-5 ml-4">
                                            <h6 class="inline mr-2">Nombres:</h6>
                                            <p class="inline"> {{newPatient.first_name}} </p>
                                        </div>
                                        <div class="vx-col md:w-1/2 lg:w-1/2 sm:w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Apellidos:</h6>
                                            <p class="inline"> {{newPatient.last_name}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Correo Electrónico:</h6>
                                            <p class="inline"> {{newPatient.email}} </p>
                                        </div>
                                        <div class="vx-col  w-full md:w-1/2 lg:w-1/2 sm:w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Sexo:</h6>
                                            <p class="inline"> {{newPatient.gender}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Fecha de Nacimiento:</h6>
                                            <p class="inline"> {{new Date(newPatient.dob).toLocaleDateString('es-ES', dateStringOptions) }} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <h6 class="inline mr-2">Celular de Contacto:</h6>
                                            <p class="inline"> {{"502"}} {{newPatient.phone}}  </p>
                                        </div>
                                        <!-- <div class="vx-col  w-full mt-2 ml-4" v-if="newPatient.phone[1]">
                                            <h6 class="inline mr-2">Teléfono de Contacto:</h6>
                                            <p class="inline"> {{newPatient.meta.phoneExt[0]}} {{newPatient.phone[1]}}  </p>
                                        </div> -->
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="newPatient.meta.personal_id">
                                            <h6 class="inline mr-2">Identificación:</h6>
                                            <p class="inline"> {{newPatient.meta.personal_id_type}} {{newPatient.meta.personal_id}}  </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="newPatient.address">
                                            <h6 class="mr-2">Dirección de Residencia:</h6>
                                            <p class="inline"> {{newPatient.address}} {{newPatient.address_2 ? newPatient.address_2 : ''}} </p>
                                            <p v-if="newPatient.zone"> {{`Zona: ${newPatient.zone} `}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-5" v-if="newPatient.country && newPatient.city">
                                            <p class="inline mr-1">{{newPatient.country.name}}</p>
                                            <p class="inline mr-1">{{newPatient.city}}</p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="newPatient.meta.doctorRefName">
                                            <h6 class="inline mr-2">Persona que lo refirió:</h6>
                                            <p class="inline mr-1">{{newPatient.meta.doctorRefName}}</p>
                                        </div>
                                        <div class="vx-col  w-full mt-2 mb-4 ml-4" v-if="newPatient.meta.doctorRefPhone">
                                            <h6 class="inline mr-2">Número del Referido:</h6>
                                            <p class="inline mr-1">{{newPatient.meta.doctorRefPhoneExt}} {{newPatient.meta.doctorRefPhone}}</p>
                                        </div>
                                        <div class="vx-col  w-full mt-4">
                                            <h5>Seguros y planes médicos</h5>
                                        </div>
                                        <div class="vx-col  w-full mt-3" >
                                            <div class="vx-row">
                                                <div class="vx-col w-1/2">
                                                    <strong class="mb-1">Aseguradora:</strong>
                                                    <p> {{newPatient.meta.insurance_plan.length > 0 ? newPatient.meta.insurance_plan : 'Sin detalle' }} </p>
                                                </div>
                                                <div class="vx-col w-1/2">
                                                    <strong class="mb-1">Póliza o número de afiliado:</strong>
                                                    <p> {{newPatient.meta.insurance_num.length > 0 ? newPatient.meta.insurance_num : 'Sin detalle' }} </p>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <vs-divider></vs-divider>
                                        <div class="vx-col  w-full mt-5">
                                            <h5>Ficha Médica</h5>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-2">
                                            <h6 class="inline mr-2">Alergías:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <p class="inline"> {{newPatient.meta.allergyBool ? 'Si':'No'}}  </p>
                                            <p v-if="newPatient.meta.allergyBool"> {{newPatient.meta.allergyVal}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-4 ml-2">
                                            <h6 class="inline mr-2">Enfermedades:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <p class="inline"> {{newPatient.meta.conditionBool ? 'Si':'No'}}  </p>
                                            <p v-if="newPatient.meta.conditionBool"> {{newPatient.meta.conditionVal}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-4 ml-2">
                                            <h6 class="inline mr-2">Medicamentos:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <p class="inline"> {{newPatient.meta.MedsBool ? 'Si':'No'}}  </p>
                                            <p v-if="newPatient.meta.MedsVal"> {{newPatient.meta.MedsVal}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-4 ml-2">
                                            <h6 class="inline mr-2">Antecedentes de Cáncer:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <p class="inline"> {{newPatient.meta.cancerBool ? 'Si':'No'}}  </p>
                                            <p v-if="newPatient.meta.cancerBool"> {{newPatient.meta.cancerVal}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-4 ml-2">
                                            <h6 class="inline mr-2">Cirugías:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <p class="inline"> {{newPatient.meta.surgeryBool ? 'Si':'No'}}  </p>
                                            <p v-if="newPatient.meta.surgeryBool"> {{newPatient.meta.surgeryVal}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-4 ml-2">
                                            <h6 class="inline mr-2">Fuma:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4">
                                            <p class="inline"> {{newPatient.meta.smoke ? 'Si':'No'}}  </p>
                                            <p v-if="newPatient.meta.smoke"> {{newPatient.meta.smokeDetail}} </p>
                                        </div>
                                        <div class="vx-col  w-full mt-4 ml-2">
                                            <h6 class="inline mr-2">Tipo de Sangre:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="newPatient.meta.blood_type">
                                            <p class="inline"> {{newPatient.meta.blood_type}}  </p>
                                        </div>
                                        <div class="vx-col  w-full mt-4 ml-2">
                                            <h6 class="inline mr-2">Estatura:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="newPatient.meta.height">
                                            <p class="inline"> {{newPatient.meta.height}} Metros  </p>
                                        </div>
                                        <div class="vx-col  w-full mt-4 ml-2">
                                            <h6 class="inline mr-2">Peso:</h6>
                                        </div>
                                        <div class="vx-col  w-full mt-2 ml-4" v-if="newPatient.meta.weight">
                                            <p class="inline"> {{newPatient.meta.weight}} Libras  </p>
                                        </div>
                                        <vs-divider></vs-divider>
                                        <div class="vx-col w-full mt-5 flex flex-col items-center">
                                            <h6 class="my-3">Términos y Condiciones</h6>
                                            <a href="/pages/patient/terms-cond" target="_blank" class="mt-3">
                                                <feather-icon icon="ExternalLinkIcon" class="mr-2" />
                                                Consultar términos y Condiciones
                                            </a>
                                            <ul class="centerx">
                                                <li>
                                                <vs-checkbox class="mt-4" name="terminos_condiciones" v-validate="'required:true'" v-model="termsCond">Acepto los términos y Condiciones</vs-checkbox>
                                                <span class="text-danger">{{ errors.first('last-step.terminos_condiciones') }}</span>
                                                </li>
                                            </ul>
                                            <ul class="centerx">
                                                <li>
                                                <vs-checkbox class="mt-4" name="consentimiento" v-validate="'required:true'" v-model="consent">
                                                    Doy mi consentimiento legal <br> para evaluación médica, <br> diagnosticada y terapéutica.
                                                </vs-checkbox>
                                                <span class="text-danger">{{ errors.first('last-step.consentimiento') }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <vs-divider></vs-divider>
                                    </div>
                                </form>
                                
                            </tab-content>
                        </form-wizard>
                    </div>
                </vx-card>
            </div>
        </div>
    </div>
</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select'
import Calendar from 'v-calendar/lib/components/calendar.umd'

// country state picker functions
import * as CSP from 'country-state-picker';
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import TreeAsyncTreeVue from '../../components/extra-components/tree/TreeAsyncTree.vue';
const ES = require("flatpickr/dist/l10n/es.js").default.es;

export default {
  data () {
    return {
      dateStringOptions:  { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' },
      defaultPhone: null,
      timeStringOptions:  { hour: 'numeric', minute: 'numeric', hour12: true },
      doc_id: null,
      infoCheck: null,
      doesExist: false,
      existingPatient: true,
      configdateTimePicker: {
        enableTime: false,
        dateFormat: 'm-d-Y',
        altInput: true,
        altFormat: 'd M Y',
        // defaultDate: new Date(),
        minDate: new Date(),
        locale: ES
      },
      consultationDetail: {
        comments_obs: null,
        diseases: [],
        medicaments: [],
        evaluationQuestions: [],
        importantNotes: null,
        physical_exam: null,
        vitalSigns: [],
        vitalSignsArr: [],
        physical_notes: null,
        previousConsultation: true,
        documents: [],
        cie10: [],
        exams: [],
        meds: [],
        usedMeds: [],
        diagnosis_eval: null,
        nextConsultation: {
          requestNext: false,
          whenQty: null,
          whenFrq: null,
        },
        consultationTotal: null,
        paymentMethod: null,
        main_symptoms: {
          pressure: false,
          fever: false,
          nausea: false,
          tiredness: false,
          fatigue: false
        }
      },
      newPatient: {
        first_name: null,
        last_name: null,
        email: null,
        dob: null,
        gender: null,
        phone: [null,null],
        notification_prefs: ['email'],
        address: null,
        address_2: null,
        zone: null,
        city: null,
        country: null,
        role: 'patient',
        idType: null,
        idNum: null,
        doctor_id: null,
        meta: {
              personal_id: null,
              personal_id_type: null,
              phoneExt: [],
              doctorRef: null,
              doctorRefName: null,
              doctorRefLastName: null,
              doctorRefPhone: null,
              doctorRefPhoneExt: null,
              prev_consultation_control: null,
              insurance_num: '',
              insurance_plan: '',
              exercise: null,
              exerciseFreq: null,
              exerciseType: null,
              exerciseTime: null,
              allergyBool: false,
              allergyVal: null,
              conditionBool: false,
              conditionVal: null,
              MedsBool: false,
              MedsVal: null,
              surgeryBool: false,
              surgeryVal: null,
              cancerBool: false,
              cancerVal: null,
              smoke: null,
              smokeDetail: null,
              weight: null,
              height: null,
              blood_type: null
          }
      },
      newPatientDef: {
        first_name: null,
        last_name: null,
        email: null,
        dob: null,
        gender: null,
        phone: [null,null],
        notification_prefs: ['email'],
        address: null,
        address_2: null,
        zone: null,
        city: null,
        country: null,
        role: 'patient',
        idType: null,
        idNum: null,
        doctor_id: null,
        meta: {
              personal_id: null,
              personal_id_type: null,
              phoneExt: [],
              doctorRef: null,
              doctorRefName: null,
              doctorRefLastName: null,
              doctorRefPhone: null,
              doctorRefPhoneExt: null,
              prev_consultation_control: null,
              insurance_num: '',
              insurance_plan: '',
              exercise: null,
              exerciseFreq: null,
              exerciseType: null,
              exerciseTime: null,
              allergyBool: false,
              allergyVal: null,
              conditionBool: false,
              conditionVal: null,
              MedsBool: false,
              MedsVal: null,
              surgeryBool: false,
              surgeryVal: null,
              cancerBool: false,
              cancerVal: null,
              smoke: null,
              smokeDetail: null,
              weight: null,
              height: null,
              blood_type: null
          }
      },
      patientData: {
          first_name: null,
          last_name: null,
          gender: null,
          dob: null,
          phone: [],
          email: null,
          address: null,
          address_2: null,
          country: {},
          role: 'patient',
          active: true,
          city: null,
          meta: {
              personal_id: null,
              personal_id_type: null,
              phoneExt: [],
              doctorRef: null,
              doctorRefName: null,
              doctorRefLastName: null,
              doctorRefPhone: null,
              doctorRefPhoneExt: null,
              prev_consultation_control: null,
              insurance_num: '',
              insurance_plan: '',
              exercise: null,
              exerciseFreq: null,
              exerciseType: null,
              exerciseTime: null,
              allergyBool: false,
              allergyVal: null,
              conditionBool: false,
              conditionVal: null,
              MedsBool: false,
              MedsVal: null,
              surgeryBool: false,
              surgeryVal: null,
              cancerBool: false,
              cancerVal: null,
              smoke: null,
              smokeDetail: null,
              weight: null,
              height: null,
              blood_type: null
          }
      },
      eventData: {
        eventType: 'consultation',
        title: null,
        notes: null,
        duration: "60",
        notification: true,
        date: null,
        timeType: 'normal',
        clinic_id: null,
        patient_id: null,
        doctor_id: null,
        zoom_email: null,
        zoom_jwt: null,
        clinicType: 'presencial',
        hour: ""
    },
      doctorData: {},
      termsCond: null,
      consent: null,
      hasActivePatient: false,
      loading: true,
    }
  },
      configdateTimePicker2: {
            enableTime: false,
            dateFormat: 'Y-m-d',
            altInput: true,
            altFormat: 'd M Y',
            defaultDate: new Date(),
            locale: ES
      },
  methods: {
      validateNewPatient(){
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('new-patient').then(result => {
          if (result) {
            this.addNewPatient();
            resolve(true);
          } else {
            reject('correct all values')
          }
        })
      })
    },
     getDateTimeTxt(){
        var tempDate = new Date(this.eventData.date.replace(/-/g, "/"));
        console.log(tempDate);
        tempDate.setHours(this.eventData.hour.split(':')[0],this.eventData.hour.split(':')[1].substring(0,2));
        // tempDate.toISOString();
        var dateStr = tempDate.toLocaleDateString('es-ES', this.dateStringOptions),
         timeStr =   tempDate.toLocaleTimeString('en-EN', this.timeStringOptions);
        this.timeSTR = dateStr + ' a las ' + timeStr;
    },
    checkExistingPatient() {
        this.$store.dispatch('getUserDataByEmailPublic', this.newPatient.email).then(response => {
            console.log(response)
            this.newPatient.first_name = response.data.data.user.first_name;
            this.newPatient.last_name = response.data.data.user.last_name;
            this.eventData.patient_id = response.data.data.user.id;
            this.newPatient.email = response.data.data.user.email;
            this.newPatient.dob = response.data.data.user.dob;
            this.newPatient.phone = response.data.data.user.phone[0];
            this.newPatient.gender = response.data.data.user.gender;
            if (response.data.data.user.meta) {
                response.data.data.user.meta.allergyBool ? this.newPatient.meta = {...this.newPatient.meta,...this.newPatient.meta} : this.newPatient.meta = this.newPatient.meta
            }
            

            this.doesExist = true;
            this.infoCheck = true;
            
        }).catch((error) => {
            this.showAlert('danger', 'Paciente No Existe', 'El correo del paciente que ingreso no existe en nuestra base de datos');
            this.newPatient = this.newPatientDef;
            this.doesExist = false;
            //this.newPatient.email = null;
            console.log(error)
            this.infoCheck = false;
        })
    },
    validateCitaMed(){
        return new Promise((resolve, reject) => {
            this.$validator.validateAll('cita-med').then(result => {
                if (result) {
                    this.getDateTimeTxt();
                    this.scroll();
                    resolve(true);
                } else {
                    reject('correct all values')
                }
            })
        });
    },
    saveCode({name, iso2, dialCode}) {
        this.newPatient.meta.phoneExt[0] = dialCode
        console.log(this.newPatient.meta.phoneExt[0])
    },
    addEvent(){
        //this.openLoading();
        console.log(this.eventData);
        let newEventObj = new Object();
        newEventObj.type = 'consultation',
        newEventObj.clinic_id = this.eventData.clinic_id,
        newEventObj.patient_id = this.eventData.patient_id
        newEventObj.doctor_id = this.$route.params.doctor_id,
        newEventObj.meta = {"status": "Solicitud"},
        newEventObj.duration = this.currentDoctorData.meta.consultationLength ? this.currentDoctorData.meta.consultationLength : 60,
        newEventObj.title = `Cita con ${this.newPatient.first_name} ${this.newPatient.last_name} ` ,
        newEventObj.notification = true;
        newEventObj.clinic_address = this.getClinicNaAd(this.eventData.clinic_id)[0];
        newEventObj.clinic_name = this.getClinicNaAd(this.eventData.clinic_id)[1];
        newEventObj.clinic_phone = this.getClinicNaAd(this.eventData.clinic_id)[2];
        newEventObj.clinic_address_2 = this.getClinicNaAd(this.eventData.clinic_id)[3];
        newEventObj.clinic_city = this.getClinicNaAd(this.eventData.clinic_id)[4];
        newEventObj.clinic_country = this.getClinicNaAd(this.eventData.clinic_id)[5];
        
        newEventObj.patient_first_name = this.newPatient.first_name;
        newEventObj.patient_last_name = this.newPatient.last_name;
        newEventObj.patient_email = this.newPatient.email;
        newEventObj.doctor_first_name = this.currentDoctorData.first_name;
        newEventObj.doctor_last_name = this.currentDoctorData.last_name;

        var customQuestionsContainer = new Array();
        //for (let index = 0; index < this.customQuestions.length; index++) {
           // let tempObj = new Object();
          //  tempObj.name = this.customQuestions[index].name;
          //  tempObj.title = this.customQuestions[index].title;
           // tempObj.instructions = this.customQuestions[index].placeholder;
          //  tempObj.active = this.customQuestions[index].active;
           // tempObj.answer = this.customQuestionsAnswers[index];
          // customQuestionsContainer.push(tempObj);
        //}


        newEventObj.meta = {...newEventObj.meta, ...this.consultationDetail, ...{'customQuestions': customQuestionsContainer}};
        console.log(this.eventData.date);
        var d = new Date(this.eventData.date.replace(/-/g, "/"));
        // console.log(tempDate);
        d.setHours(this.eventData.hour.split(':')[0],this.eventData.hour.split(':')[1].substring(0,2));
        // newEventObj.date = tempDate.toISOString();
        newEventObj.date = d.getFullYear()+ "-" + ("00" + (d.getMonth() + 1)).slice(-2) + "-" +("00" + d.getDate()).slice(-2)+"T"+ ("00" + (d.getHours())).slice(-2) + ":" +("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2)
        // return true;
        console.log(newEventObj)
        this.$store.dispatch('addEventPublic', newEventObj, true).then(response => {
            console.log(newEventObj);
            console.log(response)
            // UTF - 8
            var notifPayload2 = 
                    {
                    type:"email",
                    title:"Consulta No. "+response.data.data.event.id+" agendada exitosamente!",
                    patient_email: this.newPatient.email,
                    event_id: response.data.data.event.id,
                    patient_name: this.newPatient.first_name+' '+this.newPatient.last_name,
                    doctor_name: this.currentDoctorData.first_name+' '+this.currentDoctorData.last_name,
                    date_time: new Date(response.data.data.event.date).toLocaleDateString('es-ES', dateStringOptions)+' a las '+
                    new Date(response.data.data.event.date).toLocaleTimeString('en-EN', timeStringOptions),
                    hour: new Date(response.data.data.event.date).toLocaleTimeStirng('en-EN', timeStringOptions),
                    phone: this.newPatient.phone
                    }
            this.$store.dispatch('notifyNewConsultationScheduled', notifPayload2).then((response2) => {
                // window.location.href = '/links/confirm-s';  
                console.log('notify success', this.newPatient.phone);
            }).catch((error) => { 
                    // window.location.href = '/links/confirm-s';   
                    console.log(error);
                });

            var notifPayload = JSON.stringify(
                    {
                    "type":"push",
                    "title":"Nueva consulta #"+response.data.data.event.id+" !",
                    "message": `La consulta #${response.data.data.event.id} fue agregada por el paciente: 
                        ${this.newPatient.first_name}  ${this.newPatient.last_name} con ID # ${this.newPatient.id}`,
                    "target":{
                        "id":{"$eq":""+response.data.data.event.doctor_id+""}
                        }
                });
            
            
                // ---------------------
                const dateStringOptions =  { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
                const timeStringOptions =  { hour: 'numeric', minute: 'numeric', hour12: true };
                
                this.$store.dispatch('sendNotificationPublic', notifPayload).then((response2) => {
                    // 
                });
        }, error => {
            console.error(error);
        });
    },
    findZoomClinicsActive(){
      let zoomClinics = this.$store.state.clinics.filter(obj => {
        return ( obj.meta.type && obj.meta.type.toLowerCase() == 'virtual' )
          
          && (obj.meta.zoom_email)
          && (obj.meta.zoom_active && obj.meta.zoom_active.toLowerCase() == 'true');

      });
      console.log(zoomClinics);
      return zoomClinics
    },
    showAlert (color,title,text) {
      this.$vs.notify({
        color: color,
        title: title,
        text: text
      })
    },
    getClinicNaAd (clinic_id){
        console.log(this.docClinics);

        var result = this.docClinics.find(obj => {
            return obj.id == clinic_id
        })
        if(result){
            return [
                result.title,
                result.address,
                result.phone[0] ? result.phone[0] : '',
                result.address_2 ? result.address_2 : '',
                result.city ? result.city : '',
                result.country ? result.country : '',
                ]
        } else {
            return ['','']
        }
        
    },
    convertUTC_TIME(dateSTR){
      var d = new Date(dateSTR);
      var time = d.getHours();
      return ("00" + time).slice(-2) + ":" +("00" + d.getMinutes()).slice(-2) + `${time > 12 ? "PM": "AM"}`
    },
    addNewPatient(){
      
      console.log(this.newPatient);
      let newPatientObj = new Object();
      newPatientObj.address = this.newPatient.address,
      this.newPatient.first_name ? newPatientObj.first_name = this.newPatient.first_name : null,
      this.newPatient.last_name ? newPatientObj.last_name = this.newPatient.last_name : null,
      this.newPatient.email ? newPatientObj.email = this.newPatient.email : null,
      this.newPatient.dob ? newPatientObj.dob = this.newPatient.dob : null,
      this.newPatient.gender ? newPatientObj.gender = this.newPatient.gender : null,
      this.newPatient.phone ? newPatientObj.phone = this.newPatient.phone : null,
      this.newPatient.notification_prefs ? newPatientObj.notification_prefs = this.newPatient.notification_prefs : null,
      this.newPatient.address ? newPatientObj.address = this.newPatient.address : null,
      this.newPatient.address_2 ? newPatientObj.address_2 = this.newPatient.address_2 : null,
      this.newPatient.zone ? newPatientObj.zone = this.newPatient.zone : null,
      this.newPatient.city ? newPatientObj.city = this.newPatient.city : null,
      this.newPatient.country ? newPatientObj.country = this.newPatient.country.name : null,
      this.newPatient.role ? newPatientObj.role = this.newPatient.role : null;
      newPatientObj.doctor_id = this.$route.params.doctor_id
      newPatientObj.active = true;

      this.newPatient.idType && this.newPatient.idNum ? 
      this.newPatient.sub_specialty = this.newPatient.idType+' | '+this.newPatient.idNum : null;

      this.$store.dispatch('addPatientPublic', newPatientObj).then(response => {
            this.eventData.patient_id = response.data.data.user.id
            this.showAlert('success','Paciente Agregado','Paciente con ID#'+response.data.data.user.id+' Agregado éxitosamente!');
            //this.newPatient = this.newPatientDef;
            var notifPayload = {
              doctor_name : this.currentDoctorData.first_name + '' + this.currentDoctorData.last_name,
              patient_id: response.data.data.user.id,
              patient_name: response.data.data.user.first_name+' '+response.data.data.user.last_name,
              doctor_id: this.$route.params.doctor_id,
              email: response.data.data.user.email,
              phone: response.data.data.user.phone
            } 

            //this.$store.dispatch('sendNotificationNewPatient', notifPayload);
            
        }, error => {
            
            console.error(error.response);
            if(error.response.data.error == 'The email address is already in use by another account.') {
                
                console.log('...ya existe....');
                
                this.$store.dispatch('fetchAllUsers').then(userResponse => {
                  console.log(userResponse);
                  const matchUser = userResponse.data.data.users.find(user => user.email === newPatientObj.email);

                  if(matchUser && matchUser.role === 'patient') {
                    const linkPayload = { email: newPatientObj.email, doctor_id: this.isSecretary ? sessionStorage.getItem('activeDoctorId') : this.activeUserInfo.id };

                      this.$store.dispatch('linkUser', linkPayload).then( (response) =>{
                          this.showAlert('success','Paciente Vinculado Exitosamente!',
                            'Paciente: '+matchUser.first_name + ' '+ matchUser.last_name+'  Correo: '+matchUser.email );

                      }, error => {
                        if(error.response.data.error == 'The users were linked previously') {
                          this.showAlert('danger','Este paciente ya fue vinculado.',error.response.data.error);
                        } else {
                          console.error(error);
                        }
                        
                      });
                  } else {
                    this.showAlert('danger','No es posible vincular este usuario porque no es un paciente.',error.response.data.error);
                  }
                });
              }
              else {
                this.showAlert('danger','Error al agregar paciente.',error.response.data.error);
              }
        });
      
    },
    
    submitData () {
        this.patientData.active = true;
        this.openLoading();
        setTimeout(() => {
            this.newPatient = this.newPatientDef;
            window.location.href = '/links/confirm-s'
        }, 10000)

       
    },
    openLoading(){
      this.$vs.loading()
      setTimeout( ()=> {
        this.$vs.loading.close()
      }, 15000);
      },
    scroll(){
       window.scroll({
        top: 50,
        left: 0,
        behavior: 'smooth'
      });
    },
    validatePatientData(type) {
        this.newPatient.phone[0] = this.newPatient.meta.phoneExt[0] + this.defaultPhone
        return new Promise((resolve, reject) => {
            this.$validator.validateAll('patient-data').then(result => {
                if(this.infoCheck==false || !result) {
                    this.showAlert('danger', 'Verificar Datos', 'Porfavor verifique los datos ingresados')
                }
                if (result && this.infoCheck) {
                    console.log(result)
                    if(!this.existingPatient) {
                        this.validateNewPatient();
                    }
                    
                    this.scroll();
                    resolve(true);
                } else {
                    reject('correct all values')
                }
            })
        });
    },
    validateMidStep(type) {
         return new Promise((resolve, reject) => {
           setTimeout(() => {
               this.scroll();
               resolve(true);
           }, 100);
        });
    },
    validateLastStep(type) {
        return new Promise((resolve, reject) => {
            this.$validator.validateAll('last-step').then(result => {
                if (result) {
                    this.addEvent();
                    this.submitData();
                    resolve(true);
                } else {
                    console.log('correct all  values');
                    reject('correct all values');
                }
            })
        });
    },
    getWeekDays() {
      if(this.currentDoctorData) {
        if(this.currentDoctorData.meta && this.currentDoctorData.meta.weekDays) {
          const weekDays = this.currentDoctorData.meta.weekDays;
          return Array.isArray(weekDays) ? weekDays : null
        }
      }
      return null;
    },
    getSchedule(currentDate) {
      let day = moment(currentDate, 'MM-DD-YYYY').day();
      day = day == 0 ? 7 : day;
      const weekDays = this.getWeekDays();
      return weekDays ? weekDays.find(item => item.id ==day) : null;
    },
    formSubmitted () {
      this.addEvent();
    },
    getFormattedDate(date) {
      var year = date.getFullYear();

      var month = (1 + date.getMonth()).toString();
      month = month.length > 1 ? month : '0' + month;

      var day = date.getDate().toString();
      day = day.length > 1 ? day : '0' + day;
      
      return month + '-' + day + '-' + year;
    },
  },
  computed: {
    getCountries(){
      return CSP.getCountries();
    },
    getStates(){
      return CSP.getStates(this.newPatient.country.code);
    },
    activeClinic (){
        console.log(this.docClinics);

        var result = this.docClinics.find(obj => {
            return obj.id == this.eventData.clinic_id
        })
        if(result){
            return (result.title)
        } else {
            return ('')
        }
        
    },
    clinicAvailabilityByDate (){
      return this.$store.state.clinicAvailabilityByDate
    },
    availability (){
      return this.$store.state.schedule
    },
    docClinics () {
      let currentClinics = this.$store.state.clinics;
      console.log('CLINICAS:',currentClinics);
      // obtener clinicas virtuales de zoom y que esten activas
      var zoomClinics = this.findZoomClinicsActive();

      if (zoomClinics.length > 0){
        return currentClinics;
      } else {
        // si no ha activado 
        // let defaultVirtual = new Object();
        // defaultVirtual.title = 'Clinica Virtual Zoom',
        // defaultVirtual.meta = {"type":"Virtual", "zoom_active":"false"}
        // return [defaultVirtual, ...currentClinics];
        return currentClinics;
      }
    },
    currentPatient () {
        return this.$store.state.publicPatient;
    },
  },
  beforeCreate(){
    this.$store.dispatch('fetchClinicsPublic', this.$route.params.doctor_id);
        this.$store.dispatch('getUserDataByIdPublic', this.$route.params.doctor_id).then(response => {
            console.log(response);
            //this.newPatient = JSON.parse(JSON.stringify(response.data.data.user));
            this.loading1 = false;
            
            }, error => {
                console.error(error);
            }
        );
        this.$store.dispatch('getUserDataByIdPublic', this.$route.params.doctor_id).then(response => {
        console.log(response);
        this.currentDoctorData = JSON.parse(JSON.stringify(response.data.data.user));
        this.eventData.duration = this.currentDoctorData.meta.consultationLength ? this.currentDoctorData.meta.consultationLength : 60 ;
        // dynamic questions
        if(this.currentDoctorData.meta.consultation_questions){
            this.customQuestions = JSON.parse(JSON.stringify(this.currentDoctorData.meta.consultation_questions))
            this.customQuestionsAnswers = new Array(this.customQuestions.length);
            this.consultationDetail.consultationTotal =  this.currentDoctorData.meta.defaultPrice;
            
        }
        // 
        this.loading2 = false;
        this.$store.dispatch('fetchEventsPublic', this.$route.params.doctor_id).then(response => {
            console.log(response);
        }, error => {
            console.error(error);
        }); 
    }, error => {
        console.error(error);
    }
    );  
  },
  created(){
      console.log(this.$route);
      if(this.$route.params.doctor_id){
          console.log(this.$route.params.doctor_id);
          //this.hasActivePatient = true;
        this.$store.dispatch('getUserDataByIdPublic', this.$route.params.doctor_id).then(response => {
                console.log(response);
                this.doctorData = JSON.parse(JSON.stringify(response.data.data.user));
                var tempMeta = {...this.doctorData.meta};

                this.doctorData.meta = tempMeta;
                console.log(this.doctorData)
                this.loading = false;
            }, error => {
                console.error(error);
            }
        ); 
      } else { 
          this.loading = false;
          this.hasActivePatient = false;
      }
  },
  watch: {
    'eventData.date': function(newVal, oldVal) {
      // creating request payload
      console.log(newVal);
      try {
          var DateSelected = new Date(newVal.replace(/-/g, "/"));
          var DateAfter = new Date(DateSelected);
      } catch (error) {
          var DateSelected = new Date(newVal);
          var DateAfter = new Date(DateSelected);
          console.error(error);
      }
      
      DateAfter.setDate(DateAfter.getDate()+1);
      this.eventData.hour = null;
      
      // -------- fetching clinic schedule by date --------
      var fetchClinicSchedule_payload = new Object();
      fetchClinicSchedule_payload.clinic_id = this.eventData.clinic_id,
      fetchClinicSchedule_payload.start_date = DateSelected.toISOString().split('T')[0]+'T06:00',
      fetchClinicSchedule_payload.end_date = DateAfter.toISOString().split('T')[0]+'T05:59',
      fetchClinicSchedule_payload.requestDate = new Date().toISOString().substring(0,16),
      fetchClinicSchedule_payload.eventLength = this.eventData.duration;
      fetchClinicSchedule_payload.doctor_id = this.$route.params.doctor_id;

      if(this.eventData.clinic_id && this.eventData.duration){
        console.log(fetchClinicSchedule_payload)
        this.$store.dispatch('fetchClinicSchedulePublic', fetchClinicSchedule_payload).then(response => {
          console.log('RESPONSE: ',response);
        }, error => {
            console.error(error);
        }); 
      }
    },
    'eventData.clinic_id': function(newVal, oldVal) {
      let currClinic = this.$store.state.clinics.filter(obj => {
        return ( obj.id  ==  newVal )
      });
      this.currClinic =  currClinic[0];
      console.log(this.currClinic)
    },
    'existingPatient': function(newVal, oldVal) {
        this.infoCheck = true;
        console.log(this.existingPatient, this.infoCheck)
    }},
  components: {
    FormWizard,
    TabContent,
    Datepicker,
    vSelect,
    Calendar,
    flatPickr
  }
}
</script>
<style scoped>
body{
        touch-action: manipulation;
    }

</style>
<style> 

.overflow {
    overflow:visible;
  }
  .style-chooser .vs__dropdown-menu {
    max-height: 200px;
  }
  .vue-country-select {
      max-height: 70%;
  }
  </style>